import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  departmentChanged() {
    this.element.requestSubmit();
  }
}
